import MembersPaginationInfo from './MembersPaginationInfo.component';

export default MembersPaginationInfo;